export default "__VITE_ASSET__C0aX8jlj__"